import "./ProjectCard.css"

const ProjectCard = ({ project }) => {
  const { title, description, image, technologies, link } = project

  return (
    <div className="project-card">
      <div className="project-image">
        <img src={image || "/placeholder.svg"} alt={title} />
      </div>
      <div className="project-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="project-tech">
          {technologies.map((tech, index) => (
            <span key={index} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>
        {link && (
          <a href={link} className="project-link" target="_blank" rel="noopener noreferrer">
            View Project <i className="fas fa-arrow-right"></i>
          </a>
        )}
      </div>
    </div>
  )
}

export default ProjectCard

